// Simulated rewarded-ad playback until AdMob (or similar) is wired.

import { isNativeAdsReady } from "./nativePlatform";

/** Seconds the preview ad must play before the reward unlocks. */
export const REWARDED_AD_PREVIEW_DURATION_SEC = 10;

/**
 * True when taps should show the in-app preview ad instead of a real SDK ad.
 */
export function shouldUseRewardedAdPreview() {
    return !isNativeAdsReady();
}
